import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
    // Vérifier la session admin persistée au démarrage
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [adminCredentials, setAdminCredentials] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // Vérifier la session au démarrage
    useEffect(() => {
        const checkAdminSession = () => {
            try {
                const sessionData = sessionStorage.getItem('adminSession');
                if (sessionData) {
                    const { credentials, timestamp } = JSON.parse(sessionData);
                    const now = new Date().getTime();
                    const sessionAge = now - timestamp;
                    
                    // Session valide pour 2 heures (comme JWT)
                    if (sessionAge < 2 * 60 * 60 * 1000) {
                        setAdminCredentials(credentials);
                        setIsAuthenticated(true);} else {
                        // Session expirée
                        sessionStorage.removeItem('adminSession');}
                }
            } catch (error) {
                console.error('Erreur vérification session admin:', error);
                sessionStorage.removeItem('adminSession');
            } finally {
                setIsLoading(false);
            }
        };

        checkAdminSession();
    }, []);

    const loginAdmin = async (username, password) => {
        setIsLoading(true);
        try {
            // Identifiants admin simples pour sécurité de base
            const ADMIN_USERNAME = process.env.REACT_APP_ADMIN_USERNAME || 'admin';
            const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || 'admin123';
            
            if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
                const credentials = {
                    username: username,
                    loginTime: new Date().toISOString()
                };
                
                // Sauvegarder la session avec timestamp
                const sessionData = {
                    credentials,
                    timestamp: new Date().getTime()
                };
                sessionStorage.setItem('adminSession', JSON.stringify(sessionData));
                
                setAdminCredentials(credentials);
                setIsAuthenticated(true);return { success: true };
            } else {
                throw new Error('Identifiants administrateur invalides');
            }
        } catch (error) {
            console.error('Erreur login admin:', error.message);
            return { success: false, error: error.message };
        } finally {
            setIsLoading(false);
        }
    };

    const logoutAdmin = () => {
        setIsAuthenticated(false);
        setAdminCredentials(null);
        sessionStorage.removeItem('adminSession');};

    const value = {
        isAuthenticated,
        adminCredentials,
        isLoading,
        loginAdmin,
        logoutAdmin
    };

    return (
        <AdminAuthContext.Provider value={value}>
            {children}
        </AdminAuthContext.Provider>
    );
};

export const useAdminAuth = () => {
    const context = useContext(AdminAuthContext);
    if (!context) {
        throw new Error('useAdminAuth must be used within an AdminAuthProvider');
    }
    return context;
};
